import { SwitchCard } from '@app/components/form/SwitchCard';
import { ReactNode } from 'react';
import { useController } from 'react-hook-form';

interface SwitchCardFieldProps {
  /** Boolean field name in the surrounding form. */
  name: string;
  label: ReactNode;
  description?: ReactNode;
  disabled?: boolean;
}

/** SwitchCard bound to a boolean field of the surrounding FormContainer. */
export function SwitchCardField({ name, label, description, disabled }: SwitchCardFieldProps) {
  const { field } = useController({ name });

  return (
    <SwitchCard
      label={label}
      description={description}
      disabled={disabled}
      checked={Boolean(field.value)}
      onChange={field.onChange}
    />
  );
}
